import { GlobalConstantsTableCols } from "globales-projekt-angular";

export class ConstantsErgebnisTableColsBerechnungen extends GlobalConstantsTableCols {
  static readonly GESAMTEMISSION: string = 'GESAMTEMISSION';
  static readonly EMISSIONSSCHWERPUNKT_X: string = 'EMISSIONSSCHWERPUNKT_X';
  static readonly EMISSIONSSCHWERPUNKT_Y: string = 'EMISSIONSSCHWERPUNKT_Y';
  static readonly ZUSATZABSTAND: string = 'ZUSATZABSTAND'; 

  public static getColumns(): string[] {
    return [
      this.BEZEICHNUNG,
      this.BESCHREIBUNG,
      this.GESAMTEMISSION,
      this.EMISSIONSSCHWERPUNKT_X,
      this.EMISSIONSSCHWERPUNKT_Y,
      this.ZUSATZABSTAND, 
      this.DOWNLOAD_EXCEL_PDF_EXPORT
    ];
  }
}
